<div class="orange-money-shops" body-padding-remover>
    <div class="container">
        <div class="row orange-money-shops-no-margin-bottom">
            <div class="col-xs-12 col-sm-8 col-sm-offset-2">
                <search-box geolocate-on-map-ready="::ctrl.geolocateOnMapReady"></search-box>
            </div>
        </div>
    </div>
    <map open-shop-details-url-in-new-window="true"></map>
</div>